/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "__barrel_optimize__?names=Box!=!@mui/material";
import { useParams } from "next/navigation";
import { useState } from "react";
import NewsCard from "./NewsCard";
import { categories, categoryLabels, newsItems } from "./newsData";
export default function NewsContent() {
    const params = useParams();
    const lng = (params === null || params === void 0 ? void 0 : params.lng) === "de" ? "de" : "en";
    const [activeCategory, setActiveCategory] = useState("all");
    const [expandedId, setExpandedId] = useState(null);
    const filteredItems = activeCategory === "all" ? newsItems : newsItems.filter((item)=>item.category === activeCategory);
    return /*#__PURE__*/ _jsxs(Box, {
        sx: {
            width: "100%",
            maxWidth: "1400px",
            margin: "0 auto",
            boxSizing: "border-box",
            paddingBottom: {
                xs: "72px",
                md: 0
            }
        },
        children: [
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    border: "1px solid #FFAA00",
                    borderRadius: "10px",
                    overflow: "hidden",
                    marginBottom: "22px",
                    "@media (min-width: 768px)": {
                        gridTemplateColumns: "repeat(3, 1fr)"
                    }
                },
                children: categories.map((category)=>{
                    const isActive = activeCategory === category;
                    return /*#__PURE__*/ _jsx(Box, {
                        component: "button",
                        type: "button",
                        onClick: ()=>{
                            setActiveCategory(category);
                            setExpandedId(null);
                        },
                        sx: {
                            border: 0,
                            backgroundColor: isActive ? "#FFF7E5" : "#FFF",
                            color: isActive ? "#FFAA00" : "#000",
                            cursor: "pointer",
                            padding: {
                                xs: "12px 14px",
                                md: "12px 18px"
                            },
                            fontSize: {
                                xs: "13px",
                                md: "14px"
                            },
                            fontFamily: "inherit",
                            textTransform: "uppercase",
                            textAlign: "left",
                            overflowWrap: "break-word",
                            wordBreak: "break-word",
                            lineHeight: 1.35,
                            transition: "background-color 160ms ease, color 160ms ease",
                            "&:hover": {
                                backgroundColor: "#FFF7E5",
                                color: "#FFAA00"
                            }
                        },
                        children: categoryLabels[lng][category]
                    }, category);
                })
            }),
            /*#__PURE__*/ _jsx(Box, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px"
                },
                children: filteredItems.map((item)=>{
                    const isExpanded = expandedId === item.id;
                    const translation = item.translations[lng];
                    return /*#__PURE__*/ _jsx(NewsCard, {
                        item: item,
                        translation: translation,
                        categoryLabel: categoryLabels[lng][item.category],
                        isExpanded: isExpanded,
                        onToggle: ()=>setExpandedId(isExpanded ? null : item.id)
                    }, item.id);
                })
            })
        ]
    });
}
